var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCamera2 = function SvgIconCamera2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M8 .2a1.2 1.2 0 0 0-1.2 1.2V2H2A1.2 1.2 0 0 0 .8 3.2V14A1.2 1.2 0 0 0 2 15.2h18a1.2 1.2 0 0 0 1.2-1.2V3.2A1.2 1.2 0 0 0 20 2h-4.8v-.6A1.2 1.2 0 0 0 14 .2zm3 13.2a4.8 4.8 0 1 1 0-9.6 4.8 4.8 0 0 1 0 9.6m2.4-4.8a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconCamera2;